import { css } from '@emotion/core';
import { findLastIndex, unset } from 'lodash';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../../utils/constants';

export const commonCss = css({
  // height: '100vh',

  '.text_sec': {
    marginLeft: '112px',
    [MediaQueries.sm]: {
      marginLeft: '0',
    },
    [MediaQueries.md]: {
      marginLeft: '48px',
      marginRight: '21px',
    },
    [MediaQueries.lg]: {
      marginLeft: '44px',
    },
  },

  '.texttop': {
    paddingTop: '116px',

    [MediaQueries.sm]: {
      paddingTop: `${0 + 120}px`,
      paddingBottom: '0px',
    },
    [MediaQueries.md]: {
      paddingTop: '52px',
      paddingBottom: '0px',
    },
    [MediaQueries.lg]: {
      paddingTop: '100px',
      paddingBottom: '0px',
    },

    '.img_icon': {
      marginBottom: '10px',
      display: 'block',
      width: '32px',
      height: '32px',

      img: {
        width: '32px',
        height: '32px',
        position: 'relative',
        zIndex: 'unset',
      },
    },

    '.ptext': {
      marginTop: '16px',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      textAlign: 'left',

      [MediaQueries.md]: {
        marginBottom: '40px',
        fontWeight: '400',
      },
    },
  },

  h1: {
    fontSize: '48px',
    fontWeight: 500,
    lineHeight: '48px',
    letterSpacing: '-1px',
    textAlign: 'left',

    [MediaQueries.sm]: {
      fontSize: '28px',
      lineHeight: '32px',
      letterSpacing: '-0.4px',
      textAlign: 'left',
    },

    [MediaQueries.md]: {
      fontSize: '32px',
      lineHeight: '32px',
      letterSpacing: '-0.4px',
      textAlign: 'left',
    },

    [MediaQueries.lg]: {
      fontSize: '40px',
      lineHeight: '40px',
      letterSpacing: '-0.30000001192092896px',
      textAlign: 'left',
    },
  },

  p: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: '0px',
  },
});

export const DarkModeCss = css({
  '.ptext': {
    fontWeight: '300',
  },
  '.texttop': {
    h1: {
      color: '#fff',
      [MediaQueries.sm]: {
        color: '#fff',
      },
    },
  },

  h1: {
    color: '#fff',
    [MediaQueries.sm]: {
      color: '#fff',
    },
  },

  h3: {
    color: '#fff',
    [MediaQueries.sm]: {
      color: '#fff',
    },
  },

  p: {
    color: '#fff',
    [MediaQueries.sm]: {
      color: '#fff',
    },
  },
});

export const LightModeCss = css({
  color: '#393939',
  '.ptext': {
    fontWeight: '400',
  },
});
